<div
  *ngIf="!isAppointmentCarouselLoading; else loadingCarousel"
  class="appointment-carousel-container"
  data-test="appointment-carousel-container"
>
  <p-carousel
    [value]="appointmentCarouselDates"
    [numVisible]="3"
    [numScroll]="3"
    [showIndicators]="false"
    [showNavigators]="appointmentCarouselDates.length > 3"
  >
    <ng-template let-apptCarouselDate pTemplate="item">
      <div class="carousel-date-tile carousel-tile">
        <span class="carousel-date">{{ apptCarouselDate.date | date:'EEE, MMM d' }}</span>
      </div>
      <button
        class="carousel-time carousel-tile"
        [class.selected-time]="selectedTime === timeSlot.startTime" 
        *ngFor="let timeSlot of apptCarouselDate.appointments.slice(0,3)"
        (click)="clickAppointmentTime($event, timeSlot.startTime)"
        type="button"
      >
        {{ timeSlot.startTime | date:'h:mm aa' | lowercase }}
      </button>
      <span *ngIf="apptCarouselDate.appointments.length > 3" class="more-times">more</span>
    </ng-template>
  </p-carousel>
</div>

<ng-template #loadingCarousel>
  <div class="loading-carousel">
    Loading...  
  </div>
</ng-template>
